
<section class="ui segment ad-entry-banner" aria-label="上位表示広告枠エントリー受付">
  <div class="ad-entry-banner__body">
    <div class="ad-entry-banner__left">
      <div class="ad-entry-banner__left-header">
        <span class="ad-entry-banner__title">上位表示広告枠エントリーのご案内</span>
        <p class="ad-entry-banner__lead">
          例年、年末に向けて多くのお申し込みをいただくため、事前申請フォームをご用意しました。申請いただいた店舗さまから優先的にご案内します。
        </p>
      </div>
      <div class="ad-entry-banner__left-content">
        <div class="ad-entry-banner__plan-summary">
          <p class="ad-entry-banner__plan-summary-title">
            上位広告枠とは
            <span
              class="ad-entry-banner__help-mark"
              data-help="グルプラガイド（メディアサイト）の上位記事への掲載、特集記事の作成、検索ページでの上位表示ができる広告プランです。"
            >?</span>
          </p>
          <a class="ad-entry-banner__detail-link" href="https://allfit.notion.site/joui-pr" target="_blank">上位表示プランの詳細を見る</a>
        </div>
        <dl class="ad-entry-banner__schedule">
          <dt>掲載期間</dt>
          <dd>3ヶ月 / 6ヶ月</dd>
        </dl>
      </div>
    </div>
    <div class="ad-entry-banner__right">
      <div class="ad-entry-banner__action">
        <p class="ad-entry-banner__notice-title">注意事項</p>
        <ul class="ad-entry-banner__notes">
          <li>申請状況により掲載枠を調整する場合があります。</li>
          <li>掲載可否・開始条件は担当より個別にご連絡します。</li>
          <li>フォーム送信のみでは契約確定になりません。</li>
        </ul>
        <a class="ui button ad-entry-banner__button" href="https://forms.gle/2VeRRqYp4xmqJ3BH8" target="_blank">エントリーフォームへ進む</a>
      </div>
    </div>
  </div>
</section>
